import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { TranslationUtility } from '../../../utilities/TranslationUtility';

const RulesFeature = ({ categoryName, roomName, feature }) => {
  const settings = useSelector(state => state.configurator.settings);
  return (
    <div className="rules-feature">
      <div className="category-name">
        {categoryName}
        {roomName && <span className="room-name">{' - '}{roomName}</span>}
      </div>
      <div className="container-image-texts">
        <div className="image-mask">
          <div className="image-container">
            <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
          </div>
        </div>
        <div className="feature-text-container">
          <div className="feature-title-name-container">
            <div className="feature-title">
              {TranslationUtility.GetFormattedMessageForUI('ui-feature-option', 'Opción')}{` ${feature.order}`}
            </div>
            <div className="feature-name">
              {TranslationUtility.GetFormattedMessageForFeatureName(feature)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RulesFeature.propTypes = {
  categoryName: PropTypes.string.isRequired,
  roomName: PropTypes.node,
  feature: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    thumb: PropTypes.string,
    order: PropTypes.number,
  }).isRequired,
};

RulesFeature.defaultProps = {
  roomName: null,
};

export default RulesFeature;
